// ============================================================================
// CONGOLESE (LINGALA) TRANSLATIONS - BIBLE FACTS
// ============================================================================
// Makambo ya kokanisa na ntina ya Biblia

export const bibleFactsRc = [
  {
    category: "Botongami",
    text: "Biblia ezali na buku 66 oyo bakomaki na batu koleka 40 na boumeli ya bambula pene 1500",
    source: "Boyekoli ya Biblia"
  },
  {
    category: "Bobongoli",
    text: "Biblia ezali buku oyo babongolaki mingi koleka na historia, ebongolami na nkota koleka 3000",
    source: "Wycliffe Bible Translators"
  },
  {
    category: "Biversé",
    text: "Biblia mobimba ezali na biversé 31,173, ezali na 23,214 na Boyokani ya Kala mpe 7,959 na Boyokani ya Sika",
    source: "Statistique ya Biblia"
  },
  {
    category: "Bopusi",
    text: "Banzembo ezali buku ya molai koleka na Biblia mpe ezali na banzembo 150, ntango Abdiya ezali ya mokuse koleka",
    source: "Botaleli ya Biblia"
  },
  {
    category: "Historia",
    text: "Bakaya ya Ebale ya Mungwa ezali na mikanda ya Biblia banda liboso ya mbula 300 tii na mbula 100 ya Klisto, mpe eyebisi ete Biblia ezali na bosolo",
    source: "Bakambi ya bokufa"
  },
  {
    category: "Littérature",
    text: "Biblia ezali na mitindo mingi ya mikanda: historia, nzembo, bisakoli, makanda, mpe bimoniseli",
    source: "Botaleli ya littérature"
  },
  {
    category: "Bokonzi",
    text: "Biblia ezali buku oyo batangaka mingi koleka na historia, kabisa mingi ya milioni ya bakopi ekabwamaka mbula na mbula mpe ezali kopusa bato ya bikolo nyonso",
    source: "Statistique ya mokili mobimba"
  }
];

export default bibleFactsRc;
